import { useTheme } from 'styled-components';

import { Tooltip } from '@/core/components/Tooltip';

import { Icon } from '../Icons/Icon';
import { MultiButtonGroup, MultiButtonItem } from './MultiButton.styles';
import { MultiButtonProps, MultiButtonValueType } from './MultiButton.types';

const MULTI_BUTTON_TOOLTIP_ID = 'multi-button-tooltip';

export const MultiButton = <MultiButtonValue extends MultiButtonValueType>({
  isMulti,
  isDisabled,
  active,
  tabsData,
  onChange,
  isSmall = false,
}: MultiButtonProps<MultiButtonValue>) => {
  const { colors } = useTheme();

  return (
    <MultiButtonGroup isSmall={isSmall}>
      {tabsData.map(
        ({
          label,
          value,
          iconName,
          disabled: itemDisabled,
          tooltipText,
          activeBackgroundColor,
          activeTextColor,
        }) => {
          const isActive = isMulti ? active.includes(value) : active === value;

          return (
            <MultiButtonItem
              type="button"
              disabled={isDisabled || itemDisabled}
              key={value}
              isSmall={isSmall}
              isActive={isActive}
              $activeBackgroundColor={activeBackgroundColor}
              $activeTextColor={activeTextColor}
              {...(tooltipText && {
                'data-tooltip-id': MULTI_BUTTON_TOOLTIP_ID,
                'data-tooltip-content': tooltipText,
              })}
              onClick={() => {
                if (isMulti) {
                  if (isActive) {
                    onChange(active.filter(activeItem => activeItem !== value));
                  } else {
                    onChange([...active, value]);
                  }
                } else {
                  onChange(value);
                }
              }}
            >
              {iconName && (
                <Icon
                  name={iconName}
                  color={isActive ? colors.primaryText : colors.secondaryText}
                />
              )}
              {label}
            </MultiButtonItem>
          );
        }
      )}
      <Tooltip id={MULTI_BUTTON_TOOLTIP_ID} />
    </MultiButtonGroup>
  );
};
